jQuery(document).on('ready', function(){
	SPONSOR.onReady();
});




var SPONSOR = {
	onReady: function(){
		// SPONSOR.initModal();
		if (jQuery(window).width() > BASE.breakpoint )
			SPONSOR.initProgrammSponsorMenu();
		
		jQuery('.sponsor-slider').on('click', '.trigger-show-sponsor-modal', SPONSOR.initModal);
		jQuery(document).on('click', '.ghost-slider .trigger-hide-sponsor-modal', SPONSOR.destroyModal);

		jQuery('.infobox-slider:not(.slick-slider)').slick();
	},



	initModal: function(){
		jQuery('body').append('<div id="modal-sponsor" style="display: none;"></div>');
		jQuery('#modal-sponsor').append( jQuery(event.target).closest('.sponsor-slider').find('.headline-title').clone() );
		jQuery('#modal-sponsor').append( jQuery(event.target).closest('.sponsor-slider').find('.ghost-slider').clone() );
		// jQuery('#modal-sponsor').append( jQuery('.sponsor-slider').find('.ghost-slider').clone() );

		jQuery('#modal-sponsor')
			.delay( 300 )
			.fadeIn(function(){
				let slide = jQuery('.infobox-slider').slick('slickCurrentSlide');

				jQuery('#modal-sponsor .ghost-slider')
					.delay( 300 )
					.slick()
					.slick('slickGoTo', slide, true)
				});

	},



	destroyModal: function(){
		jQuery('#modal-sponsor')
			.delay( 300 )
			.fadeOut(function(){
				let slide = jQuery('#modal-sponsor .ghost-slider').slick('slickCurrentSlide');

				jQuery('.infobox-slider').slick('slickGoTo', slide, true);
				jQuery('#modal-sponsor').remove();
			});

	},



	initProgrammSponsorMenu: function(){
		if (typeof kdkJSprogrammSponsorPage !== 'undefined') { // in public-programm.php + public-sponsor-list-block.php
			var html = '<li class="menu-item is-programm-sponsor-page tile is-child"><a href="' + kdkJSprogrammSponsorPage.sponsorUrl + '">Partner &amp; Sponsoren</a></li>';
			jQuery('#main-navigation li:last-child').before(html);

			( kdkJSprogrammSponsorPage.sponsorUrl == window.location.href ) ? jQuery('.menu-item.is-programm-sponsor-page').addClass('current-menu-item') : '';

			( typeof kdkJSprogrammSponsorPage.sponsorTitle !== 'undefined' ) ? jQuery('.menu-item.is-programm-sponsor-page a').text(kdkJSprogrammSponsorPage.sponsorTitle) : '';
		}
	}
}